import { FunctionComponent, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import { IOption, Select } from "@digital-services/ui";
import { isNotEmpty, useInput } from "@ds-cps/ui";

interface Props {
  label: string;
  selectedType: string | undefined;
  disabled?: boolean;
  onInputChange?: (newValue: string, isValid: boolean) => void;
}

const OrganizationTypeDropDown: FunctionComponent<Props> = props => {
  const { label, selectedType, disabled = false, onInputChange } = props;

  const { t } = useTranslation(undefined, { keyPrefix: "organization" });

  const types = useMemo(() => {
    return [
      { label: t("types.Business.label"), value: "Business" },
      { label: t("types.Internal.label"), value: "Internal" }
    ];
  }, [t]);

  const [selectedOption, setSelectedOption] = useState<IOption | null>(null);

  useEffect(() => {
    if (selectedType) {
      const foundOption = types.find(
        type => type.value.toString() === selectedType
      );
      setSelectedOption(foundOption ?? null);
    } else {
      setSelectedOption(null);
    }
    // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedType]);

  const { isValid, errorMessage, valueChangeHandler } = useInput(
    [isNotEmpty(() => t("validation.string.not-empty", { fieldName: label }))],
    selectedType
  );
  const handleChange = (option: IOption) => {
    setSelectedOption(option);
    const { value, isValid } = valueChangeHandler(option.value.toString());
    if (onInputChange) {
      onInputChange(value, isValid);
    }
  };

  return (
    <Select
      label={label}
      id="organization-type-dropdown"
      data-testid="organization-type-dropdown"
      error={!isValid}
      placeholder={label}
      helperText={isValid ? undefined : errorMessage}
      disabled={disabled}
      options={types}
      selected={selectedOption}
      onChange={handleChange}
    />
  );
};

export default OrganizationTypeDropDown;
